import { instance } from "libs/api";

import { ApiRoutesOrders } from "../../constants";
import { DeleteResellerOrdersNotesForAdminRequestBody } from "./deleteResellerOrdersNotesForAdmin.types";

export const requestDeleteResellerOrdersNotesForAdmin = async (
  body: DeleteResellerOrdersNotesForAdminRequestBody
): Promise<void> => {
  return await instance.delete(ApiRoutesOrders.OrderNotesForAdmin, {
    data: body
  });
};
